module.exports = __webpack_public_path__ + "static/media/4.af858787.svg";